// Copyright (c) 2019 Deere & Company

export default Object.freeze({
    ADD_CLAIM_INCENTIVE_ADDITIONAL_REPAIR: 'ADD_CLAIM_INCENTIVE_ADDITIONAL_REPAIR',
    ADD_CLAIM_INCENTIVE_FILE: 'ADD_CLAIM_INCENTIVE_FILE',
    COPY_CLAIM_INCENTIVE: 'COPY_CLAIM_INCENTIVE',
    CREATE_CLAIM_INCENTIVE_LABOR: 'CREATE_CLAIM_INCENTIVE_LABOR',
    CREATE_CLAIM_INCENTIVE_OTHER_CREDIT: 'CREATE_CLAIM_INCENTIVE_OTHER_CREDIT',
    CREATE_CLAIM_INCENTIVE_PART: 'CREATE_CLAIM_INCENTIVE_PART',
    DELETE_CLAIM_INCENTIVE_FILE: 'DELETE_CLAIM_INCENTIVE_FILE',
    DELETE_CLAIM_INCENTIVE_LABOR: 'DELETE_CLAIM_INCENTIVE_LABOR',
    DELETE_CLAIM_INCENTIVE_OTHER_CREDIT: 'DELETE_CLAIM_INCENTIVE_OTHER_CREDIT',
    DELETE_CLAIM_INCENTIVE_PART: 'DELETE_CLAIM_INCENTIVE_PART',
    RESET_CLAIM_INCENTIVE: 'RESET_CLAIM_INCENTIVE',
    RESET_CLAIM_INCENTIVE_CONFIRMATION_MODAL: 'RESET_CLAIM_INCENTIVE_CONFIRMATION_MODAL',
    RESET_CLAIM_INCENTIVE_CREATE_PIN_MODAL_PIN: 'RESET_CLAIM_INCENTIVE_CREATE_PIN_MODAL_PIN',
    RESET_CLAIM_INCENTIVE_FORM_VALIDATION: 'RESET_CLAIM_INCENTIVE_FORM_VALIDATION',
    RESET_CLAIM_INCENTIVE_PRODUCT_DETAILS: 'RESET_CLAIM_INCENTIVE_PRODUCT_DETAILS',
    RESET_CLAIM_INCENTIVE_SELECTED_PROGRAM: 'RESET_CLAIM_INCENTIVE_SELECTED_PROGRAM',
    RESET_CLAIM_INCENTIVE_USE_AMOUNTS: 'RESET_CLAIM_INCENTIVE_USE_AMOUNTS',
    REVISE_CLAIM_INCENTIVE: 'REVISE_CLAIM_INCENTIVE',
    SET_CLAIM_INCENTIVE: 'SET_CLAIM_INCENTIVE',
    SET_CLAIM_INCENTIVE_CONFIRMATION_MODAL: 'SET_CLAIM_INCENTIVE_CONFIRMATION_MODAL',
    SET_CLAIM_INCENTIVE_CUSTOMER_DETAILS: 'SET_CLAIM_INCENTIVE_CUSTOMER_DETAILS',
    SET_CLAIM_INCENTIVE_PRODUCT_DETAILS: 'SET_CLAIM_INCENTIVE_PRODUCT_DETAILS',
    SET_CLAIM_INCENTVE_PART_DETAILS: 'SET_CLAIM_INCENTVE_PART_DETAILS',
    UPDATE_CLAIM_INCENTIVE_CLAIM_TYPES: 'UPDATE_CLAIM_INCENTIVE_CLAIM_TYPES',
    UPDATE_CLAIM_INCENTIVE_CREATE_CLAIM_MODAL_VISIBILITY: 'UPDATE_CLAIM_INCENTIVE_CREATE_CLAIM_MODAL_VISIBILITY',
    UPDATE_CLAIM_INCENTIVE_CREATE_PIN_MODAL_ACCOUNT: 'UPDATE_CLAIM_INCENTIVE_CREATE_PIN_MODAL_ACCOUNT',
    UPDATE_CLAIM_INCENTIVE_CREATE_PIN_MODAL_FAILURE_DATE: 'UPDATE_CLAIM_INCENTIVE_CREATE_PIN_MODAL_FAILURE_DATE',
    UPDATE_CLAIM_INCENTIVE_CREATE_PIN_MODAL_INVOICE_DATE: 'UPDATE_CLAIM_INCENTIVE_CREATE_PIN_MODAL_INVOICE_DATE',
    UPDATE_CLAIM_INCENTIVE_CREATE_PIN_MODAL_INVOICE_NUMBER: 'UPDATE_CLAIM_INCENTIVE_CREATE_PIN_MODAL_INVOICE_NUMBER',
    UPDATE_CLAIM_INCENTIVE_CREATE_PIN_MODAL_PIN: 'UPDATE_CLAIM_INCENTIVE_CREATE_PIN_MODAL_PIN',
    UPDATE_CLAIM_INCENTIVE_CREATE_PIN_MODAL_VISIBILITY: 'UPDATE_CLAIM_INCENTIVE_CREATE_PIN_MODAL_VISIBILITY',
    UPDATE_CLAIM_INCENTIVE_CUSTOMER_NAME: 'UPDATE_CLAIM_INCENTIVE_CUSTOMER_NAME',
    UPDATE_CLAIM_INCENTIVE_EMAIL: 'UPDATE_CLAIM_INCENTIVE_EMAIL',
    UPDATE_CLAIM_INCENTIVE_FAILURE_PART: 'UPDATE_CLAIM_INCENTIVE_FAILURE_PART',
    UPDATE_CLAIM_INCENTIVE_FILE_LIST: 'UPDATE_CLAIM_INCENTIVE_FILE_LIST',
    UPDATE_CLAIM_INCENTIVE_FORM_VALIDATION: 'UPDATE_CLAIM_INCENTIVE_FORM_VALIDATION',
    UPDATE_CLAIM_INCENTIVE_IS_ACTION_BUTTON_DISABLED: 'UPDATE_CLAIM_INCENTIVE_IS_ACTION_BUTTON_DISABLED',
    UPDATE_CLAIM_INCENTIVE_IS_COPIED: 'UPDATE_CLAIM_INCENTIVE_IS_COPIED',
    UPDATE_CLAIM_INCENTIVE_IS_EDITABLE: 'UPDATE_CLAIM_INCENTIVE_IS_EDITABLE',
    UPDATE_CLAIM_INCENTIVE_IS_VALID_CLAIM: 'UPDATE_CLAIM_INCENTIVE_IS_VALID_CLAIM',
    UPDATE_CLAIM_INCENTIVE_LABOR_COMMENTS: 'UPDATE_CLAIM_INCENTIVE_LABOR_COMMENTS',
    UPDATE_CLAIM_INCENTIVE_LABOR_HOURS: 'UPDATE_CLAIM_INCENTIVE_LABOR_HOURS',
    UPDATE_CLAIM_INCENTIVE_LABOR_LOCATION: 'UPDATE_CLAIM_INCENTIVE_LABOR_LOCATION',
    UPDATE_CLAIM_INCENTIVE_LABOR_TYPE: 'UPDATE_CLAIM_INCENTIVE_LABOR_TYPE',
    UPDATE_CLAIM_INCENTIVE_MODAL_MODE: 'UPDATE_CLAIM_INCENTIVE_MODAL_MODE',
    UPDATE_CLAIM_INCENTIVE_OTHER_CREDIT_AMOUNT: 'UPDATE_CLAIM_INCENTIVE_OTHER_CREDIT_AMOUNT',
    UPDATE_CLAIM_INCENTIVE_OTHER_CREDIT_COMMENTS: 'UPDATE_CLAIM_INCENTIVE_OTHER_CREDIT_COMMENTS',
    UPDATE_CLAIM_INCENTIVE_OTHER_CREDIT_DESCRIPTION: 'UPDATE_CLAIM_INCENTIVE_OTHER_CREDIT_DESCRIPTION',
    UPDATE_CLAIM_INCENTIVE_OTHER_CREDIT_DISTANCE: 'UPDATE_CLAIM_INCENTIVE_OTHER_CREDIT_DISTANCE',
    UPDATE_CLAIM_INCENTIVE_PART_FIELDS: 'UPDATE_CLAIM_INCENTIVE_PART_FIELDS',
    UPDATE_CLAIM_INCENTIVE_PART_UNIT: 'UPDATE_CLAIM_INCENTIVE_PART_UNIT',
    UPDATE_CLAIM_INCENTIVE_PIN: 'UPDATE_CLAIM_INCENTIVE_PIN',
    UPDATE_CLAIM_INCENTIVE_REPAIR_DATE: 'UPDATE_CLAIM_BATTERY_REPAIR_DATE',
    UPDATE_CLAIM_INCENTIVE_REPAIR_NUMBER: 'UPDATE_CLAIM_INCENTIVE_REPAIR_NUMBER',
    UPDATE_CLAIM_INCENTIVE_RESPONSIBLE_ACCOUNTS: 'UPDATE_CLAIM_INCENTIVE_RESPONSIBLE_ACCOUNTS',
    UPDATE_CLAIM_INCENTIVE_SELECTED_PROGRAM: 'UPDATE_CLAIM_INCENTIVE_SELECTED_PROGRAM',
    UPDATE_CLAIM_INCENTIVE_SHOW_APPLY_TRAVEL: 'UPDATE_CLAIM_INCENTIVE_SHOW_APPLY_TRAVEL',
    UPDATE_CLAIM_INCENTIVE_TECH_ID: 'UPDATE_CLAIM_INCENTIVE_TECH_ID',
    UPDATE_CLAIM_INCENTIVE_TEMPORARY_OBJECT_KEY: 'UPDATE_CLAIM_INCENTIVE_TEMPORARY_OBJECT_KEY',
    UPDATE_CLAIM_INCENTIVE_USE_AMOUNT: 'UPDATE_INCENTIVE_CLAIM_USE_AMOUNT',
    UPDATE_CLAIM_INCENTIVE_USE_AMOUNTS: 'UPDATE_CLAIM_INCENTIVE_USE_AMOUNTS',
    UPDATE_CLAIM_INCENTIVE_USE_AMOUNT_ON_PRODUCT_LOAD: 'UPDATE_CLAIM_INCENTIVE_USE_AMOUNT_ON_PRODUCT_LOAD',
    UPDATE_CLAIM_INCENTIVE_USE_AMOUNT_UNIT: 'UPDATE_CLAIM_INCENTIVE_USE_AMOUNT_UNIT',
    UPDATE_CLAIM_INCENTIVE_WORK_ORDER_ONE: 'UPDATE_CLAIM_INCENTIVE_WORK_ORDER_ONE',
    UPDATE_CLAIM_INCENTIVE_WORK_ORDER_TWO: 'UPDATE_CLAIM_INCENTIVE_WORK_ORDER_TWO'

});



// WEBPACK FOOTER //
// ./src/claim/incentive/action-list.js